import { Store } from '@ngrx/store';
import { first, map, Observable, of, switchMap } from 'rxjs';

import { ProductUid } from '../../domain/models/related-products.models';
import { mapProductsToProductUids } from '../transformers/products-to-product-uids.transformer';

import { WishlistPublicPort } from '@features/wishlist';
import { WishlistQueriesFacade } from '@features/wishlist/infrastructure/facades/queries/wishlist.queries.facades';
import { selectUserIsLogged } from '@shared/user/store/user.selectors';

export function getWishlistProductsUseCase(
    store: Store,
    wishlistQueryFacade: WishlistQueriesFacade,
): Observable<ProductUid[]> {
    const isUserLoggedIn = store.selectSignal(selectUserIsLogged)();

    if (!isUserLoggedIn) {
        return of([]);
    }

    WishlistPublicPort(store).loadWishlist();

    return wishlistQueryFacade.getWishlistStatus$().pipe(
        first((wishlistStatus) => wishlistStatus.loaded || wishlistStatus.error),
        switchMap((wishlistStatus) => {
            if (wishlistStatus.error) { return of([]); }

            return wishlistQueryFacade.getWishlist$().pipe(
                map((wishlist) => mapProductsToProductUids(wishlist.items))
            );
        }),
    );
}
